"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementStoreManager = void 0;
var ContractBase_1 = __importDefault(require("../ContractBase"));
var utils_1 = require("../../../utils");
var AgreementStoreManager = (function (_super) {
    __extends(AgreementStoreManager, _super);
    function AgreementStoreManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AgreementStoreManager.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var templateStoreManager;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templateStoreManager = new AgreementStoreManager('AgreementStoreManager');
                        return [4, templateStoreManager.init(config)];
                    case 1:
                        _a.sent();
                        return [2, templateStoreManager];
                }
            });
        });
    };
    AgreementStoreManager.prototype.getOwner = function () {
        return this.call('owner', []);
    };
    AgreementStoreManager.prototype.getAgreement = function (agreementId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, did, didOwner, templateId, conditionIds, lastUpdatedBy, blockNumberUpdated;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.call('getAgreement', [utils_1.zeroX(agreementId)])];
                    case 1:
                        _a = _b.sent(), did = _a.did, didOwner = _a.didOwner, templateId = _a.templateId, conditionIds = _a.conditionIds, lastUpdatedBy = _a.lastUpdatedBy, blockNumberUpdated = _a.blockNumberUpdated;
                        return [2, {
                                did: did,
                                didOwner: didOwner,
                                templateId: templateId,
                                conditionIds: conditionIds,
                                lastUpdatedBy: lastUpdatedBy,
                                blockNumberUpdated: +blockNumberUpdated
                            }];
                }
            });
        });
    };
    AgreementStoreManager.prototype.createAgreement = function (agreementId, did, templateId, conditionIds, timeLocks, timeOuts, actors, from) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.sendFrom('createAgreement', [
                        utils_1.zeroX(agreementId),
                        utils_1.zeroX(did),
                        utils_1.zeroX(templateId),
                        conditionIds.map(utils_1.zeroX),
                        timeLocks,
                        timeOuts,
                        actors
                    ], from)];
            });
        });
    };
    AgreementStoreManager.prototype.getAgreementCreatedEvent = function (agreementId) {
        return this.getEvent('AgreementCreated', {
            agreementId: utils_1.zeroX(agreementId)
        });
    };
    AgreementStoreManager.prototype.getAgreementActorAddedEvent = function (agreementId) {
        return this.getEvent('AgreementActorAdded', {
            agreementId: utils_1.zeroX(agreementId)
        });
    };
    return AgreementStoreManager;
}(ContractBase_1.default));
exports.AgreementStoreManager = AgreementStoreManager;
//# sourceMappingURL=AgreementStoreManager.js.map